import BasicCrosstab from './BasicCrosstab.vue'
import DataTypes from './DataTypes.vue'
import Filters from './Filters.vue'
import Formatters from './Formatters.vue'
import CalculatedFields from './CalculatedFields.vue'
import RowsOnly from './RowsOnly.vue'
import ColsOnly from './ColsOnly.vue'
import NoRowsNoCols from './NoRowsNoCols.vue'
import CustomConfiguration from './CustomConfiguration.vue'
import CustomTheme from './CustomTheme.vue'
import ScrollReverse from './ScrollReverse.vue'
import UIControls from './UIControls.vue'
import LoadData from './LoadData.vue'
import BarChart from './BarChart.vue'

export {
  BasicCrosstab,
  DataTypes,
  Filters,
  Formatters,
  CalculatedFields,
  RowsOnly,
  ColsOnly,
  NoRowsNoCols,
  CustomConfiguration,
  CustomTheme,
  ScrollReverse,
  UIControls,
  LoadData,
  BarChart
}



// WEBPACK FOOTER //
// ./docs/partials/examples/index.js